import { useState } from 'react';
import { PRODUCTS } from '../data/products';
import { ProductCard } from '../components/ProductCard';

const FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'firming', label: 'Firming' },
  { key: 'hydration', label: 'Hydration' },
  { key: 'brightening', label: 'Brightening' },
];

export default function ShopPage() {
  const [active, setActive] = useState('all');
  const list = active === 'all' ? PRODUCTS : PRODUCTS.filter((p) => p.concern === active);

  return (
    <div data-testid="shop-page" className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-16">
        <div className="md:col-span-7">
          <p className="overline mb-3">Sheet mask collection</p>
          <h1 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[1.02]">All masks. One ritual.</h1>
        </div>
        <div className="md:col-span-5 flex flex-wrap gap-2 md:justify-end">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              data-testid={`shop-filter-${f.key}`}
              onClick={() => setActive(f.key)}
              className={`px-4 py-2 text-xs uppercase tracking-[0.22em] border ${active === f.key ? 'bg-lum-text text-lum-bg border-lum-text' : 'border-lum-border text-lum-text2 hover:border-lum-text'} transition-colors`}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 lg:gap-16 items-stretch">
        {list.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>

      <div className="mt-24 text-center bg-lum-bg2 py-14 md:py-20 px-6">
        <p className="overline mb-3">Don&apos;t leave empty handed</p>
        <h3 className="font-serif-display text-3xl md:text-4xl">Stack any 2 packs · 10% off automatically.</h3>
      </div>
    </div>
  );
}
